import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@freelancer/datastore/core';
import { searchKeywordProjectsBackend } from './search-keyword-projects.backend';
import { transformSearchKeywordProjects } from './search-keyword-projects.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature(
      'searchKeywordProjects',
      transformSearchKeywordProjects,
    ),
    BackendModule.forFeature(
      'searchKeywordProjects',
      searchKeywordProjectsBackend,
    ),
  ],
})
export class DatastoreSearchKeywordProjectsModule {}
